import { init, setLocale } from './_i18n';

/** I18n plugin. */
const i18nPlugin = {
  init,
  setLocale,
};

export type * from './_config.type';

export default i18nPlugin;
